import React from 'react';
import { useParams } from 'react-router-dom';

// Casa Libre state glyphs (inline SVG, stroke = currentColor).
const IconBox = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 8 12 3 3 8v8l9 5 9-5V8z" /><path d="M3 8l9 5 9-5" /><path d="M12 13v8" /></svg>
);
const IconCheck = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
);
const IconWarn = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
);
const IconBan = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="4.93" y1="4.93" x2="19.07" y2="19.07" /></svg>
);

const AllInventory = () => {
  const { workspaceUuid } = useParams();

  const stats = [
    { label: 'Total Products', value: 124, Icon: IconBox, surface: '#FAF7F1', color: '#111111' },
    { label: 'In Stock', value: 98, Icon: IconCheck, surface: '#E4F1E9', color: '#0F6E56' },
    { label: 'Low Stock', value: 12, Icon: IconWarn, surface: '#F5EAD5', color: '#8A5A12' },
    { label: 'Out of Stock', value: 14, Icon: IconBan, surface: '#F6E4E1', color: '#B23A3A' },
  ];

  return (
    <div className="users-page-container">
      <header className="page-header">
        <div>
          <h1>Inventory Management</h1>
          <p>Real-time stock monitoring for workspace: <strong style={{ fontFamily: "'IBM Plex Mono', monospace" }}>{workspaceUuid.slice(0,8)}...</strong></p>
        </div>
        <button className="primary-btn">+ Add Item</button>
      </header>

      <div className="workspace-grid" style={{ marginTop: '32px' }}>
        {stats.map((stat) => (
          <div key={stat.label} className="workspace-card" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div style={{
              width: '56px',
              height: '56px',
              borderRadius: '14px',
              background: stat.surface,
              color: stat.color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <stat.Icon />
            </div>
            <div>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#6B6862', marginBottom: '4px' }}>{stat.label}</div>
              <div style={{ fontSize: '24px', fontWeight: '700', letterSpacing: '-0.03em', color: '#111111' }}>{stat.value}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="users-table-container" style={{ marginTop: '40px' }}>
         <table className="users-table">
            <thead>
               <tr>
                  <th>Product Name</th>
                  <th>Category</th>
                  <th>Stock</th>
                  <th>Price</th>
                  <th>Status</th>
               </tr>
            </thead>
            <tbody>
               {[
                  { name: 'Wireless Headphones', cat: 'Electronics', stock: 45, price: '$99', status: 'In Stock' },
                  { name: 'Eco-Friendly Bottle', cat: 'Home', stock: 12, price: '$25', status: 'Low Stock' },
                  { name: 'Ceramic Mug', cat: 'Kitchen', stock: 0, price: '$15', status: 'Out of Stock' },
                  { name: 'Leather Wallet', cat: 'Accessories', stock: 88, price: '$45', status: 'In Stock' }
               ].map((item, i) => (
                  <tr key={i}>
                     <td style={{ fontWeight: '600' }}>{item.name}</td>
                     <td>{item.cat}</td>
                     <td style={{ fontFamily: "'IBM Plex Mono', monospace" }}>{item.stock}</td>
                     <td style={{ fontFamily: "'IBM Plex Mono', monospace" }}>{item.price}</td>
                     <td>
                        <span className={`role-badge ${item.status.toLowerCase().replace(/ /g, '-')}`} style={{
                           borderRadius: '999px',
                           background: item.status === 'In Stock' ? '#E4F1E9' : item.status === 'Low Stock' ? '#F5EAD5' : '#F6E4E1',
                           color: item.status === 'In Stock' ? '#0F6E56' : item.status === 'Low Stock' ? '#8A5A12' : '#B23A3A'
                        }}>
                           {item.status}
                        </span>
                     </td>
                  </tr>
               ))}
            </tbody>
         </table>
      </div>
    </div>
  );
};

export default AllInventory;
